//***** require / imports scss / css *******************************//
require('./homepage.scss');
require('./../../../node_modules/magnific-popup/dist/magnific-popup.css');

//***** require / imports js *******************************//
require('./../../../node_modules/holderjs/holder.js');
require('./../../../node_modules/magnific-popup/dist/jquery.magnific-popup.js');

import ngClassified from 'ng-classified';

// import exampleObject from 'Objects/exampleObject/exampleObject.mdl.js';
import navigationen from 'Objects/navigationen/navigationen.mdl.js';
import header from 'Objects/header/header.mdl.js';
import footer from 'Objects/footer/footer.mdl.js';

import ScrollMagic from 'scrollmagic';

//***** Modul start *******************************//
angular.module('homepage', [
	'navigationen',
	'header',
	'footer'
])
.constant('$classify', true)


$( document ).ready(function() {
	console.log( "ready!" );
	// init controller


	var controller = new ScrollMagic.Controller();
	
	new ScrollMagic.Scene({
		offset:134
	})
		.setClassToggle("#carousel-id", "slider-pad")
		.addTo(controller);

	// Magnific Popup

	var config = {
		type: 'iframe',
		overflowY: 'scroll',
		callbacks: { },
		mainClass: 'magnific-custom-class'
	};
	
	$('.popup-video').magnificPopup(config);

});



// WEBPACK FOOTER //
// ./src/pages/homepage/homepage.mdl.js